import Modals from 'module.modal'
import { EVENTS } from 'util.events'

class KiteCartPopup extends HTMLElement {
  constructor() {
    super()
    this.modal = null
    this.widgetInitialized = false
    this.autoCloseTimer = null
  }

  connectedCallback() {
    this.modal = new Modals(this.id, 'kite-cart-popup', {
      trapFocus: true
    })

    document.addEventListener(EVENTS.ajaxProductAdded, this.handleProductAdded.bind(this))
  }

  async handleProductAdded(event) {
    // Check if the event aims to trigger the popup (Quick Add / Quick Shop)
    const btn = event.detail ? event.detail.addToCartBtn : null;
    let isQuickAdd = false;

    if (btn) {
        if (btn.hasAttribute('data-single-variant-quick-add')) {
            isQuickAdd = true;
        } 
        else if (btn.closest('quick-add') || btn.closest('quick-shop')) {
            isQuickAdd = true;
        }
        else if (btn.closest('[data-tool-tip-content]')) {
             isQuickAdd = true;
        }
    }
    if (!isQuickAdd) {
        return;
    }

    // Show the modal
    if (this.modal) {
      this.modal.open()
      
      // Initialize/Refresh the Kite widget
      this.initKiteWidget()

      // Auto-close the popup after 3 seconds
      if (this.autoCloseTimer) {
        clearTimeout(this.autoCloseTimer)
      }
      this.autoCloseTimer = setTimeout(() => {
        this.modal.close()
        this.autoCloseTimer = null
      }, 3000)
    }
  }

  async initKiteWidget() {
    const widgetContainer = this.querySelector('#KiteProgressBarWidget')
    if (!widgetContainer) return

    try {
      // Ensure gfg and gfgConsolidatedCustomDiscount are available
      if (typeof gfg !== 'undefined' && typeof gfgConsolidatedCustomDiscount !== 'undefined') {
        const discounts = gfg.settings.consolidatedCombinedDiscount || []
        const discount = discounts.find((d) => d.title.includes("POP_UP_WIDGET"))
        if (discount) {
          // The app documentation says this returns a DOM element
          let progressBarWidget = await gfgConsolidatedCustomDiscount.gfgProgressBar.initialize(discount, "POP_UP");
          if (progressBarWidget) {
            // Clear previous content and attach the new widget
            widgetContainer.innerHTML = ''
            widgetContainer.appendChild(progressBarWidget.generatedUI)
            this.widgetInitialized = true
          }
        } else {
          console.warn('Kite Cart Popup: Discount including "POP_UP_WIDGET" not found.')
        }
      } else {
        console.error('Kite Cart Popup: Kite app (gfg) not loaded.')
      }
    } catch (error) {
      console.error('Kite Cart Popup: Error initializing widget:', error)
    }
  }
}

if (!customElements.get('kite-cart-popup')) {
  customElements.define('kite-cart-popup', KiteCartPopup)
}